module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAGCAYAAAC8RqxsAAAAX0lEQVQ4jdXTMQ5EUABF0fNF9GZ9Yws6OhswW9DNOiwJpUQl4mtUyu+u4OblvrCNCvzwxUfaLPijydGjTlz4ooyu67H49IKl78xZWj7PyWIzb2M4Gm8RUMWGUuY8J90Oyr4PEZvZZuwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/projectBriefing/images/sp_01.png
// module id = 5PWW
// module chunks = 1